import { render, staticRenderFns } from "./CategoryHeaderRecipes.vue?vue&type=template&id=659ab5b2&scoped=true"
import script from "./CategoryHeaderRecipes.vue?vue&type=script&lang=js"
export * from "./CategoryHeaderRecipes.vue?vue&type=script&lang=js"
import style0 from "./CategoryHeaderRecipes.vue?vue&type=style&index=0&id=659ab5b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659ab5b2",
  null
  
)

export default component.exports